import { calculateOperationAPI, createInvoiceAPI, createOperationAPI, createNextTripAPI, endTripAPI, checkTripEligibilityAPI, editInvoiceAPI, getAllOperationsAPI, getAllTeamOperationsAPI, getInvoiceByIdAPI, getInvoiceDetailsAPI, getOperationByIdAPI, getOrganizationDetailsAPI, getVoyageListAPI, getCargoVoyageListAPI, postInvoiceAPI, queryByPDFdownloadAPI } from "./api";

export const getAllOperations = (params, query) => {
  return new Promise((resolve, reject) => {
    getAllOperationsAPI(params, query)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllTeamOperations = (params, query) => {
  return new Promise((resolve, reject) => {
    getAllTeamOperationsAPI(params, query)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOperationById = (params) => {
  return new Promise((resolve, reject) => {
    getOperationByIdAPI(params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const calculateOperation = (params, payload) => {
  return new Promise((resolve, reject) => {
    calculateOperationAPI(params, payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOrganizationDetails = (params) => {
  return new Promise((resolve, reject) => {
    getOrganizationDetailsAPI(params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createInvoice = (payload) => {
  return new Promise((resolve, reject) => {
    createInvoiceAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editInvoice = (payload) => {
  return new Promise((resolve, reject) => {
    editInvoiceAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postInvoice = (payload) => {
  return new Promise((resolve, reject) => {
    postInvoiceAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInvoiceById = (params) => {
  return new Promise((resolve, reject) => {
    getInvoiceByIdAPI(params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInvoiceDetails = () => {
  return new Promise((resolve, reject) => {
    getInvoiceDetailsAPI()
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const queryByPDFdownload = (queryid, isLaytimeStatement) => {
  return new Promise((resolve, reject) => {
    queryByPDFdownloadAPI(queryid, isLaytimeStatement)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createOperation = (payload) => {
  return new Promise((resolve, reject) => {
    createOperationAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createNextTrip = (payload) => {
  return new Promise((resolve, reject) => {
    createNextTripAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const endTrip = (payload) => {
  return new Promise((resolve, reject) => {
    endTripAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const checkTripEligibility = (operationId) => {
  return new Promise((resolve, reject) => {
    checkTripEligibilityAPI(operationId)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getVoyageList = (params, query) => {
  return new Promise((resolve, reject) => {
    getVoyageListAPI(params, query)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCargoVoyageList = (params, query) => {
  return new Promise((resolve, reject) => {
    getCargoVoyageListAPI(params, query)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
